import { useState, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { readString } from "react-papaparse";
// Redux
import { useSelector } from "react-redux";
// Components
import Routes from "../routes";
// Translation file
import translationsPath from "./translations/translations.csv";

const I18Next = () => {
  const [translations, setTranslations] = useState({});
  const storeLng = useSelector(({ language }) => language.lng);

  // Set translations
  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const response = await fetch(translationsPath);
        const csvText = await response.text();

        readString(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            let translations = { en: {}, es: {}, ca: {}, ua: {}, de: {}, 中文: {}, ro: {} };

            for (const row of results.data) {
              const key = row.key;
              Object.keys(translations).forEach((lang) => {
                if (row[lang]) {
                  translations[lang][key] = row[lang] === " " ? "" : row[lang];
                }
              });
            }

            setTranslations(translations);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          },
        });
      } catch (error) {
        console.error("Error fetching or initializing translations:", error);
      }
    };

    fetchTranslations();
  }, []);

  // Set language
  useEffect(() => {
    i18next.init({
      interpolation: { escapeValue: false },
      lng: storeLng,
      resources: {
        en: {
          global: translations.en || {},
        },
        es: {
          global: translations.es || {},
        },
        ca: {
          global: translations.ca || {},
        },
        ua: {
          global: translations.ua || {},
        },
        de: {
          global: translations.de || {},
        },
        中文: {
          global: translations.中文 || {},
        },
        ro: {
          global: translations.ro || {},
        },
      },
    });
  }, [storeLng, translations]);

  return (
    <I18nextProvider i18n={i18next}>
      <Routes />
    </I18nextProvider>
  );
};

export default I18Next;
